export const SECONDS = {
  MINUTE: 60,
  HOUR: 3600,
  DAY: 86_400,
  WEEK: 604_800,
  MONTH: 2_592_000,
  YEAR: 31_536_000,
};
